import { Component, Inject, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ImportReportModel } from '@app/core/models/administration/imports/import-report.model';
import { ErrorCodeHelper } from '@app/core/models/error-codeHelper';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { takeUntil } from 'rxjs/operators';
import { Subject, Observable } from 'rxjs';
import { UploadComponent } from '@app/shared/components/upload/upload.component';
import * as _ from 'lodash';

@Component({
  selector: 'app-import-items',
  templateUrl: './import-items.component.html',
  styleUrls: ['./import-items.component.scss']
})
export class ImportItemsComponent implements OnInit, OnDestroy {

  importHandler: (files: File[]) => Observable<ImportReportModel[]>;
  title: string;

  unsubscribe$: Subject<boolean> = new Subject<boolean>();
  filesImported: boolean = false;
  ImportReports: ImportReportModel[];

  @ViewChild(UploadComponent) uploadComponent: UploadComponent;

  constructor(
    private dialogRef: MatDialogRef<ImportItemsComponent>,
    private errorCodeHelper: ErrorCodeHelper,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) data) {
    this.importHandler = data.importHandler;
    this.ImportReports = [];
  }

  ngOnInit(): void {
  }

  errorMessage(errorCode: string): string {
    return this.errorCodeHelper.getErrorMessage(errorCode);
  }

  onSubmit() {
    if (!this.hasFiles) {
      return;
    }

    this.importHandler(this.uploadComponent.Files)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((reports: ImportReportModel[]) => {
        this.ImportReports = reports;
        this.filesImported = true;
      });
  }

  close() {
    this.dialogRef.close(this.filesImported);
  }

  get hasFiles(): boolean {
    return !_.isNil(this.uploadComponent) && this.uploadComponent.hasFiles;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
  }
}
